import React from "react";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleSignInButton = ({ label = "Continue with Google", testid = "google-signin" }) => {
  const startGoogleAuth = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={startGoogleAuth}
      className="w-full flex items-center justify-center gap-3 bg-white text-black font-bold uppercase tracking-[0.15em] text-xs px-4 py-3 hover:-translate-y-0.5 transition-transform"
    >
      <GoogleLogo size={18} weight="bold" />
      {label}
    </button>
  );
};

export const AuthDivider = () => (
  <div className="flex items-center gap-3 my-6">
    <div className="flex-1 h-px bg-white/10" />
    <span className="text-[10px] uppercase tracking-[0.25em] text-white/30">or with email</span>
    <div className="flex-1 h-px bg-white/10" />
  </div>
);
